module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="header__content">\n	<div class="l-header">\n		<div class="l-header__logo">\n			<a href="/" class="logo"></a>\n		</div>\n		<div class="l-header__navigation navigation__region">\n		</div>\n		<div class="l-header__account account__region">\n		logout\n			<div class="l-header__account-panel">\n				<ul class="account-navigation">\n					<li>Settings</li>\n					<li>Logout</li>\n				</ul>\n			</div>\n		</div>\n	</div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/header/list/templates/layout.html
// module id = 450
// module chunks = 0